const prefix = '__lekker__'

export { prefix }
